import { toastSuccess } from "../../toasts";
import { FrameComponent } from "../frames/frame-component";
import { ParameterComponent } from "./parameter-component";
export class ParameterComponentInplace extends ParameterComponent {
    static webComponentName: string = "parameters-input-inplace";
    protected manageModeGlobalClassName = 'parameters-manage-mode-inplace';
    get frameController(): FrameComponent | null {
        return window.frameController || null;
    }
    private frameClose(): void {
        if (this.frameController) {
            this.frameController.close();
        }
    }
    protected afterSave () : void {
        this.frameController!.actionExecuted = true;
        toastSuccess("Parametro salvato con successo.");
        setTimeout(() => {
            this.frameClose();
        }, 200);
    }
    protected afterRender(): void {
        // Esegue il setup standard del componente padre
        super.afterRender();

        // Mostra direttamente lo step "manage" e renderizza la form (modalità add di default)
        if (this.addParameterBtn) {
            this.goToStep(this.steps.manage, this.addParameterBtn, true);
        } else {
            this.goToStep(this.steps.manage, this as any, true);
        }
        // Se è presente un parametro corrente, ricarica la form in modalità "edit"
        const maybeSwitchToEdit = () => {
            if (this.step === this.steps.manage && this.editParameterBtn && this.current) {
                const form = this.parametersForm;
                const isEdit = form?.dataset.action === 'edit';
                if (!isEdit) {
                    this.goToStep(this.steps.manage, this.editParameterBtn, true);
                }
            }
        };

        // Prova subito (se i dati sono già disponibili)
        maybeSwitchToEdit();

        // E quando cambia il valore (es. dopo preload async)
        this.addEventListener('value-changed', () => {
            maybeSwitchToEdit();
        });
    }
}
